import classNames from "classnames"
import React from "react"

import "./PageWithSidebar.scss"

type PageWithSidebarProps = {
  className?: string
} & React.HTMLAttributes<HTMLDivElement>

export default function PageWithSidebar(props: PageWithSidebarProps) {
  const { className, ...rest } = props

  const usedClassName = classNames("PageWithSidebar", className)

  return <div className={usedClassName} {...rest} />
}
